<div class="wrapper-legend">
  @for (speed of colors; track speed) {
    <div class="speed">
      <div class="color" [style.background-color]="speed.color"></div>
      <div class="value">>{{ speed.speedMin }}km/h</div>
    </div>
  }
</div>
